define([
    'text!product-detail/component/knowledge-tab-item.html',

    'css!product-detail/component/knowledge-tab-item.css'
], function(
    tpl
){
    return {
        template: tpl,
        props: {
            item: {
                type: Object
            },
            isOpen: {
                type: Boolean
            }
        },
        computed: {
            controlText: function(){
                return this.isOpen ? '-' : '+';
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./product-detail/component/knowledge-tab-item.js
// module id = 206
// module chunks = 0